import * as React from "react";
import { forwardRef } from "react";
const SvgStar = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" ref={ref} {...props}><path fill="#F5AC38" fillRule="evenodd" d="M9.901 6.214 8.24 2.928 6.579 6.214l-3.734.53 2.702 2.572-.635 3.62 3.328-1.709 3.329 1.71-.636-3.621 2.702-2.572-3.734-.53Z" clipRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgStar);
export default ForwardRef;